import type { PublicRole } from "../../lib/api-types.js";

/** 角色是否为管理员角色（code==="admin" 或 dosia.templateId==="admin"）。 */
export function isAdminRole(role: PublicRole): boolean {
  if (role.code === "admin") return true;
  const dosia = role.dosia as { templateId?: string } | undefined;
  return dosia?.templateId === "admin";
}
